import services from './../../../services/service'; // Service Class
import validation from './../../../services/validation'; // Service Class
import Commons from '../../../resources/commons.js'; //Commons class
import MainHeader from './../../MainHeader/index.vue'; // Main Header
import MainFooter from './../../MainFooter/index.vue'; // Main Footer
import Orders from './../../../components/order/Orders/index.vue';
import PaymentService from './../../PaymentService/index.vue'; //Payment service
import ProductItemForm from '../../../components/product/ProductItemForm.vue' //
import AccountDropMenu from '../../../components/templates/account-menu.vue' //
//
import OrdersData from './../../../components/order/Orders/script.js';

let service = new services();
let validator = new validation();

export default {
    name: 'Account',
    mixins: [Commons,OrdersData],
    data () {
        return {
            user: {},
            sellpoints:{},
            sellpoint:{},
            business:{}, //binds to sellpoints
            products:{},
            product:{},
            product_item_group:{},
            product_item:{},
            categories:{},
            category:{},
            main_category:{},
            sub_categories:[],
            validate_user_name_error:false,
            validate_user_name_message:"",
            product_is_wholesale:false,

            //business settings
            business_agent:0,
            business_details:{},
            business_product_categories:[],
            business_service_categories:[],
            business_category_type:0,
            
            //product settings
            product_display_image:{},
            product_item:{},
            file_info: {},
            files_info:[], //muttiple files
            imageForm: "",
            imagesFormArray: [], //multiple files
            is_product_service: "product",
            max_upload: service.max_media_upload,
            prdItemPriceKey:0,
            productOrdersComponentKey:0,
            product_details:{},
            orderComponentKey:0,
            
            
            //productitems settings
            show_product_setting_box:false,
            showProductItemGroups:"",
            tap_01:0,
            //...more--settings

            
            //services-more
            service_duration:"",
            service_offers:[],
            service_offer:{},

            //utilities
            data_call_to_actions:{},
            data_components_services:{},
            img_url: service.imageURL,
            loading:true,
            sellpoint_loading:true,
            action_loading:false,
            disable_btn:false,
            data_processing_message:"",
            data_error_message:"",
            data_success_message:"",
            data_media_error_message:"",
            max_media_info:service.max_upload_image_info,
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            setSettings:false,
            setting_details:{},
        

            //core confirmed settings
            current_sellpoint_id:0,
            market_groups: {},
            app_orders:{},
            order:{},
            viewOrder:false,
            viewPendingPayOrder:false,
            viewPendingPayOrders:false,
            sellpoint_orders:{},
            sellpoint_pending_orders:{},
            sellpoint_transactions:{},
            processing_fee:{},
            set_order_pending_payment_data:"",
            set_pending_payment_data:{},

            //payment gateways
            payment_gateways:{}, 
            ravepay_bank_list:{},
            ravepay_sba:{}, //ravepay_subaccount

            //
            component_loading:{},
            businessComponentKey:0,

            //mgts
            manageBusinessDetails: false,

            //
            is_viewing: "Account", //default
            set_menu:  false,
            menu_view:{},
            menu_tab_view:{},
            menu_tab_inner_view:{},
            menu_link:{},
            back_link_view: 1, //default
            prev_menu_link: '',
            current_menu_link: '',
            prev_menu_tab_view: '',
            current_menu_tab_view: '',
            customers: {},
            reco_products:{},
            has_sellpoints: false,
            productAddView02ComponentKey:0,
            //
            set_orders:{},
            set_orders_items:{},
        }
    },

    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter,
        'product-item-form': ProductItemForm,
        'component-account-menu': AccountDropMenu,
        'component-orders': Orders,
        'component-payment-service': PaymentService,
    },
     
    methods: {
        //---defaults
        setHistoryState(state_view){
            //let state = {'menu_link': prev_menu_link, 'menu_tab_view': prev_menu_tab_view, 'back_link_view':this.back_link_view}; //fetch at popstate
            let state = {'menu_link': this.prev_menu_link, 'menu_tab_view': this.prev_menu_tab_view, 'back_link_view':this.back_link_view}; //fetch at popstate
            let title = state_view;
            let url = '';//'/account';
            history.pushState(state, title, url);
        },

        back(){
            window.history.back(); 
        },

        toggleMenu(){
            if(this.set_menu == false){
                this.set_menu = true;
            }else if(this.set_menu == true){
                this.set_menu = false;
            }
        },

        toggleMenuTabView(view,attr1,attr2){
            if(this.menu_tab_view[view] == true){
                this.menu_tab_view = {};
                this.menu_tab_view['viewBusiness'] = true;
            }else{
                this.menu_tab_inner_view = {};
                this.menu_tab_view = {};
                this.menu_tab_view[view] = true;
            }
        },

      

        setMenuLink(view){
            //--do-some-resets
            this.prev_menu_link = view; //this.current_menu_link;
            this.current_menu_link = view;
            //--./some-resets
            
            this.menu_link = {};
            this.menu_link[view] = true;
            this.set_menu = false;
            //
            this.setHistoryState(view);
        },

        setMenuTabView(type,view,attr1,attr2){
            this.menu_tab_inner_view = {};
            this.menu_tab_view = {};
            this.menu_tab_view[view] = true;

            //--with back_menu_link
            if(type == 'business'){
                this.back_link_view = type; // 2; //secondary
                this.prev_menu_link = type;//this.current_menu_link;
                this.prev_menu_tab_view = view;
                //this.current_menu_tab_view = view;
            
                //
                this.setHistoryState(view);
            }

        },

        setMenuTabInnerView(view,attr1,attr2){
            this.setComponent('reset-edit','');
            this.menu_tab_inner_view = {};
            this.menu_tab_inner_view[view] = true;
        },

        //---default--settings
        reloadToView(){
            //store preset components //use ids
            this.current_sellpoint_id = this.sellpoint.business_id;

            let view_1 = Object.keys(this.menu_view)[0];
            let view_2 = Object.keys(this.menu_tab_view)[0];
            //load more
            
            //reload preset
            this.preset(); 
            //then set view
            this.setMenuComponent(view_1,'','');
            this.setMenuTabView(view_2,'','');
        },


        setComponentLoading(view,attr1,attr2){
            this.component_loading = {};
            this.component_loading[view] = true;
        },

        setComponent(attr1,attr2){
            this.data_processing_message = ""; //refresh
            this.deactivate_processing(); //first deactivate any active processing

    
            if(attr1 == 'reset-edit'){ 
                this.discount_coupon = {};
                this.business_details = {};
                this.product_details = {};
                this.setting_details ={};
                this.main_category = {}; //recheck
                this.setSettings = false;
                this.viewOrder = false;
                this.viewPendingPayOrder = false;
                this.viewPost = false;
                this.data_success_message = "";
                this.data_error_message = "";
                this.data_processing_message= "";
                this.showProductItemGroups = "";
            }

            if(attr1 == 'reset-component-details'){
                this.manageBusinessDetails = false;
            }
            
            //more ///move up after app_clean
            if(attr1 == "orders"){
                this.order = attr2;
                this.viewOrder = true;
            }

            if(attr1 == "pending_pay_orders"){
                this.order = attr2;
                this.viewPendingPayOrder = true;
            }

            if(attr1 == "posts"){
                this.post = attr2;
                this.viewPost = true;
            }
            

        },
        
        openModal(id) {
            document.getElementById(id).style.display = "block";
        },
        
        closeModal(id) {
            document.getElementById(id).style.display = "none";
        },

        numStrip(){
            if(this.product.product_item_price && (this.product.product_item_price > 0)){
                this.product.product_item_price = this.product.product_item_price.replace( /[^0-9.,]/g, '' );
            }
            //
            if(this.product.product_item_set_moq_price && (this.product.product_item_set_moq_price > 0)){
                this.product.product_item_set_moq_price = this.product.product_item_set_moq_price.replace( /[^0-9.,]/g, '' );
            }
            this.prdItemPriceKey++;    
        },

        numStrip01(){
            if(this.product.product_items[0].product_item_price && (this.product.product_items[0].product_item_price > 0)){
                this.product.product_items[0].product_item_price = this.product.product_items[0].product_item_price.replace( /[^0-9.,]/g, '' );
            }
            //
            if(this.product.product_items[0].product_item_set_moq_price && (this.product.product_items[0].product_item_set_moq_price > 0)){
                this.product.product_items[0].product_item_set_moq_price = this.product.product_items[0].product_item_set_moq_price.replace( /[^0-9.,]/g, '' );
            }
            this.prdItemPriceKey++;    
        },
        
        setMenuComponent(view,view_type,attr1,attr2){  
            this.setPanel = true;
            
            var top = document.getElementById("topPanel").offsetTop;
            window.scrollTo(0, top); 

            this.menu_view = {};
            this.menu_view[view] = true;
            
            
        //     //set view tree
        //     this.setViewTree(view,view_type,attr1,attr2);

        //     //scaler//activator
        //    this.resetPageSettings(view);
        },

        setBusinessComponent(view,attr1,attr2){
            if(view == "sellpoints"){
                this.sellpoint = this.sellpoints[0];// pick first sellpointattr1;
                //call all sellpoint get data
                this.setSellpoint();
            }
            this.resetMessages();
            // console.log(this.is_view+"---"+this.is_viewed)
            this.setPanel = true;
            this.resetPageSettings(view); //page headers and menus
            if(view != "sellpoints"){
                this.sellpoint = attr1;
                //call all sellpoint get data
                this.setSellpoint();
            }else{
                this.setMenuTabView('business','viewBusiness');
            }
            // this.is_viewed = this.is_view;
            this.is_view = view;
            this.is_view_type = "business";
            this.is_viewing = this.sellpoint.business_username;  //this.sellpoint.business_name

            //new entries check
            let entry_array = ["newBusiness","newBusinessCategory","newBusinessCategoryProduct","newBusinessAgentCategoryProduct"];
            
            if(entry_array.indexOf(view) != -1){
                if(view == 'newBusiness'){this.sellpoint = {}; this.business = {}; this.sellpoint = {}; this.business_agent = 0;}
                if(view == 'newBusinessCategory'){this.main_category = {}; this.category = {};}
                if(view == 'newBusinessCategoryProduct'){this.product = {};}
                if(view == 'newBusinessAgentCategoryProduct'){this.product = {};}
            }
            //sellpoint check
            //agent special
            if(view == 'viewBusiness'){
                this.setMenuTabView('business','viewBusiness');
                // this.setPageHeaders();
                // setTimeout(function(){ document.getElementById('viewBusiness').style.color = service.app_default_color }, 500); //wait for 3sec and call posts in gallery
            }
            this.main_category = {};
            //categories check
            let category_array = ["viewBusinessCategory","editBusinessCategory","removeBusinessCategory"];
            
            if(category_array.indexOf(view) != -1){
                this.category = attr2;
                
                //agent special
                if(view == 'viewBusinessCategory'){
                    this.getBusinessCategoryProducts();
                    if(this.sellpoint.business_agent == 1){
                        this.getBusinessAgentCategoryProducts();
                        this.getBusinessesIsOpenAgentCategoryProducts();
                    }
                    this.setMenuTabView('business','viewBusinessCategory');
                    // this.setPageHeaders();
                    // setTimeout(function(){ document.getElementById('viewBusinessCategory').style.color = service.app_default_color }, 1500); //wait for 3sec and call posts in gallery
                
                }
            }


            //products check
            let product_array = ["viewBusinessCategoryProduct","editBusinessCategoryProduct","removeBusinessCategoryProduct"];
            
            if(product_array.indexOf(view) != -1){
                // this.product = attr2;
                this.setProductComponent(attr2);
                //this two lines below is now called in the function above
                // this.product_display_image = this.product.product_images[0];
                // this.product_item = this.product.product_items[0];

                //restore settings
                this.is_viewed = "viewBusinessCategory";
                // this.category = 
                //agent special
                if(view == 'viewBusinessCategoryProduct'){
                    this.setMenuTabView('business','viewBusinessCategoryProduct');
                    // this.setPageHeaders();
                    // setTimeout(function(){ document.getElementById('viewBusinessCategoryProduct').style.color = service.app_default_color }, 500); //wait for 3sec and call posts in gallery
                }
            }


            
            this.menu_view = {};
            this.menu_view[view] = true;
            //this.setViewTree(view,"sellpoints",attr1,attr2); 
        },

        setProductComponent(item){
            this.loading = true;
            service.getProductSearch(this, item.product_url_name).then(response => {
                if(response.body.status == 200) {
                    this.loading = false;
                    this.product = response.body.data;
                    this.product_display_image = this.product.product_images[0];
                    this.product_item = this.product.product_items[0];
                    // if(this.product.product_item_groups.length != 0){
                    //     this.product_item_group = this.product.product_item_groups[0];
                    // }else{
                    //     this.product_item_group = [];
                    // }

                    //prep sets
                    if((!this.product.set_product_addons) || (Object.keys(this.product.set_product_addons).length == 0)){
                        this.product.set_product_addons = [];
                    }
                    
                    //new hack to make sure category is set for back options
                    if(Object.keys(this.category).length === 0){
                        //set this product's category
                        for(let category of this.sellpoint.business_categories){
                            if(this.product.product_category_id == category.business_category_id){
                                this.category = category;
                                //other settings
                                this.getBusinessCategoryProducts();  /// try filter already sellpoint products for PERf
                            }
                        }
                    }
                    
                    //filter orders
                    this.product.product_orders = [];
                    for(let ord of this.sellpoint.orders){
                        for(let ord_item of ord.order_items){
                            if(this.product.product_id == ord_item.product_id){
                                let ord_array = {};
                                ord_array.order_product = ord_item.product_id; 
                                ord_array.order_date = ord.order_date; 
                                ord_array.order_time_ago = ord.order_time_ago; 
                                ord_array.order_user = ord.order_user;
                                ord_array.order_item_quantity = ord_item.order_item_quantity;
                                ord_array.order_status_id = ord.order_status_id; 
                                ord_array.order_status = ord.order_status;
                                ord_array.order_status_color = ord.order_status_color; 
                                ord_array.order_payment_status_id = ord.order_payment_status_id;
                                ord_array.order_payment_status = ord.order_payment_status;
                                ord_array.order_payment_status_color = ord.order_payment_status_color;
                                this.product.product_orders.push(ord_array);
                                this.productOrdersComponentKey++;
                            }
                        }
                    }
                    
                }
            }).catch((err) => {})
        },

        //reset main substitute
        resetAll(){
            this.discount_coupon = {};
            this.business_details = {};
            this.product_details = {};
            this.data_success_message = "";
            this.data_error_message = "";
            this.data_processing_message= "";
        },

        resetMessages(){
            this.data_success_message = "";
            this.data_error_message = "";
            this.data_processing_message= "";
            this.deactivate_processing(); //hack in here
        },

        resetFormData(){
            this.file_info = {};
            this.files_info = [];
        },

        resetPageSettings(view){
            if((view == 'viewBusiness') || (view == 'viewBusinessCategory') || (view == 'viewBusinessCategoryProduct')){
                //this.setPageHeaders(view);
                setTimeout(function(){ 
                    if(document.getElementById(view) != null){
                        document.getElementById(view).style.color = service.app_default_color;
                    }
                }, 50);
            }
        },

        //---validates
        //validate user name
        validateUserName(){
            service.validateBusinessUserName(this, this.business).then(response => {
                if(response.body.status != 200) {
                    this.validate_user_name_error = true;
                    this.validate_user_name_message = "This username already exist";
                    this.deactivate_processing();
                }else{this.validate_user_name_error = false;}
            }).catch((err) => {
                //log it
                this.validate_user_name_error = true;
                this.validate_user_name_message = "This username already exist";
                this.deactivate_processing();
            })
        },

        //---user
        preset() {
            this.loading = true;
            let self = this;
        
            ///
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user.user_id = value.user_id;
                    //special case for profile
                    self.getUser(self.user.user_id);
                    //../special case for profile
                    // self.loading = false;
                }else {
                    self.$router.push('login');
                }
            });
        },

        //user settings
        getUser(user_id){
            service.getUser(this, user_id).then(data => {
                if(data.body.status == 200) {
                    //get other user details
                    let user_data = data.body.data;
                    this.user.user_email = user_data.user_email;
                    this.user.user_member_id = user_data.user_member_id;
                    this.user.user_name = user_data.user_name;
                    this.user.user_phone = user_data.user_phone;
                    this.user.user_token = user_data.user_token;
                    this.user.user_ref = user_data.user_ref;

                    //set main view
                    if(this.$route.query.t == "newsp"){
                        this.setMenuLink('business');
                        this.setNewBusiness();
                    }

                   // this.loading = false;
                    // this.user = data.body.data;
                    //get user app settings
                    this.getUserAppSettings();
                    this.getSellpoints(user_id);
                    //
                    this.getOrders();
                }
            }).catch((err) => {
                if(err) {
                    // toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        getUserAppSettings(){
            service.getUserAppSettings(this, this.user.user_id).then(data => {
                if(data.body.status == 200) {
                    this.user_settings = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                    // toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },
        
        getOrders(){
            service.getOrders(this, this.user.user_id).then(response => {
                if(response.body.status == 200) {
                    this.set_orders = response.body.data;
                    this.set_orders_items = [];
                    for(let order of this.set_orders){
                        for(let item of order.order_items){
                            this.set_orders_items.push(item);
                        }
                    }
                }
            }).catch((err) => {
                //console.log(err) //possibly a load payment error
            })
        },

        //market settings
        getBusinessMarketGroups() {
            service.getBusinessMarketGroups(this).then(function(data) {
                this.market_groups = data.body.data;
            })
        },


        //sellpoints////
        setNewBusiness(){
            //some settts
            this.sellpoint = {}; this.business = {}; this.sellpoint = {}; this.business_agent = 0;
            this.setMenuComponent('newBusiness');
        },

        getSellpoints(user){
            // this.loading = true; //disable for now
            //this.loading = false;
            service.getAppBusinesses(this, user).then(data => {
                if(data.body.status == 200) {
                    this.sellpoints = data.body.data;
                    if(this.sellpoints.length > 0){
                        if(this.current_sellpoint_id != 0){
                            for(let sellpoint of this.sellpoints){
                                if(sellpoint.business_id == this.current_sellpoint_id){
                                    this.sellpoint = sellpoint;
                                }
                            }
                        }else{
                            this.sellpoint = this.sellpoints[0];
                        }
                        this.business_set_shipping_fee_status = this.sellpoint.business_set_shipping_fee_status;
                        //set sellpoint
                        this.setSellpoint();
                        this.has_sellpoints = true;
                    }else{
                        this.has_sellpoints = false;
                        //this.loading = false; //disable for now
                    }
                }else{
                    //this.loading = false; //disable for now
                }
            }).catch((err) => {
                if(err) {
                   //log it
                  // console.log(err)
                  this.loading = false; //disable for now
                }
            })
        },

        setSellpoint(){ 
            if(Object.keys(this.sellpoint).length > 0){
                //check if sellpoint is saved on forage
                //use current sellpoint
                //some settings
                if(this.sellpoint.business_category_type == 1){
                    this.is_product_service = "product";
                }
                if(this.sellpoint.business_category_type == 2){
                    this.is_product_service = "service";
                }
                //get Products
                this.getSellpointProductsDEPRAC(); //hack here for  now for /// get requests like get posts
                //get Orders
                this.getAppBusinessOrders();
                //get prnding order payments
                this.getAppBusinessOrdersPendingPayments();
                //get transactions
                this.getAppBusinessTransactions();
                //get Customers
                this.getAppBusinessCustomers();
                //
                //this.getBusinessRewardSettings();
                //continue
                //new-get new categories
                this.getMainCategories(this.sellpoint.business_category_id);
                //set sellpoint categories
                this.getSellpointCategories();
                //get posts
                this.getAppBusinessPosts();
                //
                this.loading = false; //disable for now
                //this.sellpoint_loading = false; execute at getAppBusinessOrders for now since its the longst time exec
           // }
            }else{
                this.loading = false; //disable for now
                this.sellpoint_loading = false; 
            }
        },

        getSellpointProductsDEPRAC(){
            this.sellpoint.business_market_products_limit = 1000; //hack in here
            service.getAppBusinessProducts(this, this.sellpoint.business_id, this.sellpoint.business_market_products_limit).then(response => {
                if(response.body.status == 200) {
                    this.products = response.body.data; 
                } 
            }).catch((err) => {})
        },

        //---transactions---settings----/
        getAppBusinessTransactions(){
            service.getAppBusinessTransactions(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) {
                    this.sellpoint_transactions.transactions = response.body.data;
                    this.sellpoint_transactions.transactions_total = response.body.data_total;
                    this.sellpoint_transactions.transactions_total_amount = response.body.data_total_amount;
                    this.sellpoint_transactions.transactions_total_today = response.body.data_total_today;
                    this.sellpoint_transactions.transactions_total_today_amount = response.body.data_total_today_amount;
                }
            }).catch((err) => { })
        },
        //---transactions---settings---/

        //---customers---settings----/
        getAppBusinessCustomers(){
            service.getAppBusinessCustomers(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) {
                    this.customers = response.body.data;
                }
            }).catch((err) => { })
        },

        getAppBusinessOrders(){
            //for fast trace maybe get recent orders then call func for full orders
            service.getAppBusinessOrders(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) {
                    this.sellpoint_orders = response.body.data;
                    this.sellpoint.orders = response.body.data;
                    // this.componentOrdersKey++;
                    // console.log(this.sellpoint.orders)
                    //
                    this.sellpoint_loading = false; 
                }
            }).catch((err) => {
                //console.log(err) //possibly a load payment error
            })
        },

        getAppBusinessOrdersPendingPayments(){
            service.getAppBusinessOrdersPendingPayments(this, 3, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) {
                    this.sellpoint_pending_orders = response.body.data;
                }
            }).catch((err) => {
                //console.log(err) //possibly a load payment error
            })
        },

        getAppBusinessPosts(){ //2 business
            service.getXPosts(this, 2, this.sellpoint.business_id,0,50).then(response => {
                if(response.body.status == 200) {
                    this.posts = response.body.data;
                }
            }).catch((err) => { })
        },

        //categories
        getCategories() {
            service.getCategories(this).then(function(data) {
                let categories = data.body.data;
                //seperate products and services categories
                categories.forEach(function(element) {
                    if(element.category_type == 1){
                        this.business_product_categories.push(element);
                    }
                    if(element.category_type == 2){
                        this.business_service_categories.push(element);
                    }
                }, this);
            })
        },

        getMainCategories(category){
            service.getMainCategories(this, category).then(response => {
               if(response.body.status == 200) {
                    this.categories = response.body.data;
                }
            }).catch((err) => {})
        },

        getSubCategories(category){
            if(category != undefined){
                this.sub_categories = category.sub_categories;
            }else{
                this.sub_categories = [];
            }
            
        },

        //categories settings
        getSellpointCategories(){
            service.getBusinessCategories(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) {
                    this.sellpoint_categories = response.body.data;
                }
            }).catch((err) => {})
        },

        getBusinessCategoryProducts(category_view){
            if(category_view != ''){
                this.setComponentLoading(category_view);
            }else{  
                this.loading = true;
            }
            service.getCategoryProducts(this, this.category.business_category_id).then(response => {
                if(response.body.status == 200) {
                  this.category.category_products = response.body.data;
                  this.businessComponentKey++;
                  this.attachProductsComponentKey++;

                  //
                  //this.loading = false;
                  this.setComponentLoading('');
                }
            }).catch((err) => {this.loading = false})
        },

        resetCategoriesSelections(){
            if(this.category.new_listed_category != ''){
                this.main_category = {};
                this.category.new_category = 0;
            }
        },

        addCategory(){
            this.activate_processing();
            var payload = {
                category_new: this.category.new_category || 0,
                category_new_listed: this.category.new_listed_category || "nill",
                category_parent: this.main_category.category_id || 0,
                business_id: this.sellpoint.business_id
            }
            // if((payload.category_new == 0) && (payload.category_new_listed == "nill")){
            if((payload.category_parent == 0) && (payload.category_new == 0) && (payload.category_new_listed == "nill")){
                this.data_error_message = "You did not pick any category, Select or any enter the category name";
                this.deactivate_processing();
            }else{
                service.addCategory(this, payload).then(function(data) {
                    if(data.body.status == 201) {
                        this.data_processing_message = "Sellpoint Category Added Successfully";
                        this.sellpoint.business_categories = data.body.data;
                        this.category = {};
                    }else{
                        this.data_error_message = "Sorry could not process request, try again";
                    }
                    this.deactivate_processing();
                    //this.setBusinessComponent("viewBusiness",this.sellpoint,''); //back
                    this.setMenuTabView('business','viewBusiness',this.sellpoint,'');
                    this.menu_view = {};//this.setMenuComponent('',this.sellpoint,'');
                }).catch((err) => {
                    //log it
                    this.data_error_message = "Sorry could not process request, try again";
                    this.deactivate_processing();
                })
            }
            
        },

        editCategory(){
            this.activate_processing();
            this.category.business_id = this.sellpoint.business_id;
            service.editCategory(this, this.category).then(function(data) {
                if(data.body.status == 200) {
                    // toastr.success("Sellpoint Category edited", 'Success!');
                    this.data_processing_message = "Sellpoint Category edited";
                    this.sellpoint.business_categories = data.body.data;
                    this.setComponent('reset-edit','');
                    this.deactivate_processing();
                    // this.category = {};
                }
            }).catch((err) => {
                this.data_processing_message = "Sellpoint Category could not be edited";
                this.setComponent('reset-edit','');
            })
        },

        deleteCategory(){
            this.setComponent('reset-edit','');
        },

        
        //----------Administrations,,,
        //---sellpoints
        //add new business // //market business registration with basic free payment
        setUpNewBusiness(){
            this.resetAll();
            
            // this.disable_btn = true;
            this.activate_processing();
            var credentials = {
                business_name: this.business.business_name,
                business_user_name: this.business.business_user_name,
                business_category: this.business.business_category || 1,
                business_owner: this.user.user_id,
                business_group: service.market_app_name,
                business_market_group: this.business.business_market_group, //market group in this market
                business_layout: 1, //shop
                business_agent: this.business_agent, //shop
                business_subscription: 1, //defalut / basic //no payment to register in this market 
                business_join_group: 0, //this.active_group.group_id || 0,  
            }
            let navi = this.$router;
            if(this.validate_user_name_error){
                this.data_error_message = "This Username already exists..";
                this.deactivate_processing();
            }else{
                if(credentials.business_name != undefined && credentials.business_category != undefined) {
                    service.addNewBusiness(this, credentials).then(function(data) {
                        if(data.body.status == 201) {
                            // toastr.success("Sellpoint Creation Successfull", 'Success!');
                            this.business.business_user_name = data.body.data_business_username; //overide from server
                            this.data_processing_message = "Sellpoint Creation Successful.";

                            //notify server of Order-Delivered
                            // this.notifyPayments(16,this.payment_ref,this.business.business_user_name); //16--Subscription-Delivered
                            
                            this.sellpoint = data.body.data;
                            //navigate to business view
                            
                            this.setBusinessComponent('viewBusiness',this.sellpoint,'');
                            this.reloadToView();//core_reload
                            this.deactivate_processing();
                            this.resetAll();

                            
                            //
                            //location.reload(); //use for now till sort business component
                            
                            //

                        }else{
                            this.data_error_message = "This Username already exists";
                            this.deactivate_processing();
                        }
                    }).catch((err) => {
                        if(err) {
                            this.data_error_message = "Something went wrong";
                            this.deactivate_processing();
                        }
                    })
                }else {
                    this.data_error_message = "Kindly fill all fields";
                    this.deactivate_processing();
                }
            }
        },

        //editbusiness
        editBusinessDetails(attr){
            this.activate_processing();
            if(attr == "delivery"){
                var payload = {
                    business_id: this.sellpoint.business_id,
                    business_delivery_information: this.sellpoint.business_delivery_information
                }
            }else{
                var payload = {
                    business_main_details:true,
                    business_id: this.sellpoint.business_id,
                    business_name: this.sellpoint.business_name,
                    business_tagline: this.sellpoint.business_tagline,
                    business_profile: this.sellpoint.business_profile,
                    business_emails: this.sellpoint.business_emails,
                    business_address: this.sellpoint.business_address,
                    business_phones: this.sellpoint.business_phones
                }
            }
            service.editBusinessDetails(this, payload).then(function(data) {
                if((data.body.status == 200) || (data.body.status == 400)) {
                    this.data_processing_message = "Sellpoint edited";
                    if(attr == "delivery"){
                        this.business_details = {};
                    }else{
                        this.manageBusinessDetails = false;
                        //show top
                        this.setComponent("reset-edit","");
                        var top = document.getElementById("topPanel").offsetTop;
                        window.scrollTo(0, top); 
                        this.deactivate_processing();
                    }
                    // this.setComponent("reset-edit","");
                }else{
                    this.data_processing_message = "Could not edit details, something went wrong, please try again";
                    this.deactivate_processing();
                }
                
            }).catch((err) => {
                //log it
                this.data_processing_message = "Could not edit details, something went wrong, please try again";
                this.deactivate_processing();
            })
        },

        //----Products
        addToServiceOffers(offer){
            //check
            // this.service_offers.push(offer)
            if((offer.offer_set != undefined) || (offer.offer_new_offer != undefined)){
                if((offer.offer_set != undefined) && (offer.offer_limit != undefined)){
                    //some settings for displays
                    offer.offer = offer.offer_set.business_service_offer_id;
                    offer.offer_name = offer.offer_set.business_service_offer;
                    offer.offer_type_name = offer.offer_set.business_service_offer_type_name;
                    offer.offer_limit = offer.offer_limit;
                    offer.offer_set_actions = {};
                    offer.offer_set_actions.data_action_name = offer.offer_set.business_service_offer_action_name;
                    this.service_offers.push(offer);
                }
                if(offer.offer_new_offer != undefined){
                    offer.offer_type = offer.offer_type_set.data_service_id;
                    offer.offer_type_name = offer.offer_type_set.data_service_name;
                    if((offer.offer_type != undefined) && (offer.offer_limit != undefined) && (offer.offer_set_actions != undefined)){
                        offer.offer_action = offer.offer_set_actions.data_action_id;//reset
                        this.service_offers.push(offer);
                    }
                }
                this.service_offer = {}; //refresh
            }
        },
        
        addCategoryAndProduct(){
            this.activate_processing();
            if(this.category.set_category && (Object.keys(this.category.set_category).length > 0)){
                this.category = this.category.set_category;
                this.addProduct();
            }else{
                //prep add category
                var payload = {
                    category_new: this.category.new_category || 0,
                    category_new_listed: this.category.new_listed_category || "nill",
                    category_parent: this.main_category.category_id || 0,
                    business_id: this.sellpoint.business_id
                }
                if((payload.category_parent == 0) && (payload.category_new == 0) && (payload.category_new_listed == "nill")){
                    this.data_error_message = "You did not pick any category, Select or any enter the category name";
                    this.deactivate_processing();
                }else{
                    service.addCategory(this, payload).then(function(data) {
                        if(data.body.status == 201) {
                            this.data_processing_message = "Sellpoint Category Added Successfully";
                            this.sellpoint.business_categories = data.body.data;
                            this.category = this.sellpoint.business_categories[(this.sellpoint.business_categories.length)-1];
                            this.addProduct();
                        }
                    }).catch((err) => {
                        //log it
                        this.data_error_message = "Sorry could not process request, try again";
                        this.deactivate_processing();
                    })
                }
            }
        },

        addProduct(){
            this.resetMessages(); //reset
            this.activate_processing();
            let can_submit = true;
            //some checks
            if((this.service_offers.length == 0) && ((Object.keys(this.service_offer).length > 0))){ //if user forgot to click the add offer btn
                this.addToServiceOffers(this.service_offer);
            }
            if(this.product.product_is_subscribed_to){
                this.product.product_is_subscribed_to = 1;
            }else{
                this.product.product_is_subscribed_to = 0;
            }
            //wholesale settings
            if(this.product_is_wholesale){
                if((this.product.product_item_set_moq > 0) || (this.product.product_item_set_moq_price > 0)){
                    can_submit = true;
                }else{
                    can_submit = false;
                }
                if((this.product.product_item_price <= 0) || (this.product.product_item_price == '') || (this.product.product_item_price == undefined)){
                    this.product.product_item_price = this.product.product_item_set_moq_price;
                }
            }
            // this.loading = true;
            var credentials = {
                product_name: this.product.product_name,
                product_is_product_or_service: this.is_product_service,
                product_category_is_set: this.category.business_category_id || 0,
                product_business: this.sellpoint.business_id,
                product_description: this.product.product_description || "nill",
                // product_item_price: this.product.product_item_price.replace(/\D+/g, ''),/^[0-9.,]+$/
                product_item_price: this.product.product_item_price,
                product_item_weight: this.product.product_item_weight || 1,
                product_item_quantity: this.product.product_item_quantity || 100,
                product_is_subscribed_to: this.product.product_is_subscribed_to,
                product_service_offers: this.service_offers,
            }
            
            let navi = this.$router;
            if(can_submit && ((credentials.product_name != undefined) && (credentials.product_item_price > 0))) {
                service.addProduct(this, credentials).then(function(data) {
                    if(data.body.status == 201) {
                        this.data_success_message = "Processing, please wait ...";
                        
                        // this.product = data.body.data; //to avoid force form input resets
                        let product = data.body.data;
                        
                        //add image
                        this.imageForm.append("data_id", product.product_id);
                        this.imageForm.append("data_type","products");
                        service.uploadDataPhoto(this, this.imageForm).then(data => {
                            if(data.body.status == 200){
                                //this.setBusinessComponent('viewBusinessCategory',this.sellpoint,this.category);
                                this.deactivate_processing();
                                this.resetFormData()
                            }else{
                                this.data_processing_message = service.upload_media_error_msg;
                                // this.deactivate_processing();
                                //reset after timed out warning
                                setTimeout(function(){  
                                    //self.setBusinessComponent('viewBusinessCategory',self.sellpoint,self.category);
                                    self.deactivate_processing();
                                    self.resetFormData();
                                }, service.timeout_msg_wait_period); 
                            }
                        }).catch((err) => {
                            if(err) {}
                            this.data_error_message = service.upload_media_error_msg;
                            this.deactivate_processing();
                            this.resetFormData();
                        })

                        //if uploading takes time continue with calls in the kipper
                        let self = this;
                        setTimeout(function(){  
                            //self.setBusinessComponent('viewBusinessCategory',self.sellpoint,self.category);
                            self.deactivate_processing();
                            self.resetFormData();
                        }, service.upload_wait_period); //wait and call posts in gallery

                        //refershs
                        this.service_offers = {};

                    }
                }).catch((err) => {
                    if(err) {
                        console.log(err);
                        this.data_error_message = "Something went wrong, preparing report ...";
                        //this.setBusinessComponent('viewBusinessCategory',this.sellpoint,this.category);
                        this.deactivate_processing();
                        this.resetFormData()
                    }
                })
            }else {
                // toastr.error('Kindly fill all fields', 'Warning!');
                this.data_error_message = "Kindly fill all fields ...";
                this.deactivate_processing();
            }
        },

        //utilities
        getUtilities(){
            service.getUtilities(this).then(response => {
                this.data_call_to_actions = response.body.data_call_to_actions;
                this.data_components_services = response.body.data_components_services;
            }).catch((err) => {
                if(err) {
                    // log it
                }
            })
        },

        //------------------settings
        //uploads
        onFileChangePrep(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (files.length)
            {   
                this.file_info = files;
                let formData = new FormData();
                formData.append('photo', files[0]); 
                this.imageForm = formData;
            }   
        
        },

        onFileChangeMultiplePrep(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (files.length > 0)
            {   
                this.files_info = files;
                for(let file of files){
                    let formData = new FormData();
                    formData.append('photo', file); 
                    this.imagesFormArray.push(formData);
                }
            } 
        },

        onFileChange(e,type,data_id) {
            this.resetMessages(); //reset
            this.product_details = {}; //hack
            this.product_details.uploading_image = true;
            this.activate_processing();
            let files = e.target.files || e.dataTransfer.files;
            if (files.length)
            {
                let formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', type);  
                // formData.append('data_id', this.product_item.product_item_id);
                // formData.append('data_type', "product_items");   

                this.imageForm = formData;
                // if(!this.product_details.uploading_image){ //hack for disable double request
                    service.uploadDataPhoto(this, formData).then(data => {
                        if(data.body.status == 200){
                            if(type == "business_category"){
                                this.category.business_category_image = data.body.data;
                            }
                            // if(type == "product_item"){
                            //     this.product_item.product_item_image = data.body.data;
                            // }
                            if(type == "products"){
                                this.getProductImages();
                                if(this.product_details.editProductItemGroup){ //ie product_item_group edit going on
                                    this.product_item_group.product_item_group_image = data.body.data_id;
                                }
                            }
                            
                            if(type == "product_information"){
                                this.getProductInformation();
                            }

                            
                            this.deactivate_processing();
                            
                        }else{
                            this.data_processing_message = service.upload_media_error_msg;
                            this.deactivate_processing();
                        }
                        this.product_details.uploading_image = false;
                    }).catch((err) => {
                        this.data_processing_message = service.upload_media_error_msg;
                        this.deactivate_processing();
                        this.product_details.uploading_image = false;
                    })
                }
            // }   
                
        },

        //producta
        onFileChangeNewProduct(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (files.length)
            {   
                this.file_info = files;
                let formData = new FormData();
                formData.append('photo', files[0]); 
                this.imageForm = formData;
            }   
        
        },
        //productitems
        onFileChangeProductItems(e,type,data_id) {
            this.activate_processing();
            let files = e.target.files || e.dataTransfer.files;
            if (files.length)
            {
                let formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', type);  
                this.imageForm = formData;
                service.uploadDataPhoto(this, formData).then(data => {
                    if(data.body.status == 200){
                        if(type == "products"){
                            this.product.product_item_group_image = data.body.data_id;
                            // this.data_media_error_message = "";
                            this.getProductImages();
                        }
                    }
                }).catch((err) => {
                    if(err) {
                        // log it
                    }
                })
                //if uploading takes time continue with reload
                this.data_media_error_message = service.media_upload_timeout_msg;
                let self = this;
                setTimeout(function(){  self.data_media_error_message; }, 65000); //wait for 1min and timeout
                setTimeout(function(){  
                    // location.reload(true); 
                    self.data_media_error_message = "";
                }, 95000); //wait for 1min and timeout
            }   
                
        },
      
    },

   

    mounted: function(){
        let self = this
        
    },

    created: function(){ 
        document.title = "Account" + "";
        this.getStates();
        this.getUtilities();
        this.getCategories();
        this.getBusinessMarketGroups();
        this.preset();

    }
}


// WEBPACK FOOTER //
// ./src/pages/Account/Resources/script.js